import axios from './axios'

export async function getRequest(URL, headers={}) {
    return axios.get(`/${URL}`,{headers: headers}).then(response => response)
}

export async function postRequest(URL, payload, headers={}) {
    return axios.post(`/${URL}`, payload, {headers:headers}).then(response => response)
}

export async function patchRequest(URL, payload, headers={}) {
    return axios.patch(`/${URL}`, payload, {headers:headers}).then(response => response)
}

export async function deleteRequest(URL, headers={}) {
    return axios.delete(`/${URL}`, {headers:headers}).then(response => response)
}